class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;
    this.getCart().then((cart) => {
      this.cartData = cart;
    });
    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add("m-cart-drawer--active");
    requestAnimationFrame(() => {
      this.style.setProperty("--m-bg-opacity", "0.5");
      this.cartDrawerInner.style.setProperty("--translate-x", "0");
    });
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add("prevent-scroll");
    const complementaryProducts = this.querySelector('cart-complementary-products');
    if(complementaryProducts){
      console.log('complementaryProducts',complementaryProducts)
      complementaryProducts.refreshSlider();
    }
  }

  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          console.log(`Updating section: ${section.id}  ${section.block}`);
          if (section.block === "cart-items") {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
    this.getCart().then((cart) => {
      this.cartData = cart;
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    console.log('getSectionInnerHTML called with selector:', selector);
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
     
      {
        id: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      
    ];
  }
//  {
//         id: "cart-drawer",
//         selector: "[data-minimog-cart-discounts]",
//         block: "cart-footer",
//       },
// {
//         id: "cart-drawer",
//         selector: "[data-minimog-gift-wrapping]",
//         block: "cart-footer",
//       },
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]", 
      },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);

class RewardPointsBox extends HTMLElement {
  constructor() {
    super();
    this.discountAmount = 0;
    this.discountCode = null;
    this.discountKey = "EckoDiscountCode"; // use code, not boolean
    this.innerHTML = `<div class="cart-login-reward"><span>Loading reward points...</span></div>`;
  }

  async connectedCallback() {
    const customerId = window.loggedInCustomerId;

    if (!customerId || customerId === "null") {
      // Remove discount
      const _storeCode = localStorage.getItem(this.discountKey);
      if(_storeCode){
        // check if cart actually has a discount applied
        const cart = await this.fetchCart();
        if (cart.discount_codes && cart.discount_codes.length > 0) {
          const appliedDiscounts = cart?.discount_codes || [];
         // Check if stored code exists in cart discounts
          const match = appliedDiscounts.find(d => d.code === _storeCode && d.applicable);
          if (match) {
            // only then clear discount from cart
            this.applyDiscount("");
            localStorage.removeItem(this.discountKey);
          }
        }
      }
      this.renderLoginUI();
      return;
    }

    // fetch cart first, then points
    Promise.all([this.fetchCart(), this.fetchCustomerInfo(customerId)])
      .then(([cart]) => {
        this.handleStoredDiscount(cart);
      });
  }

  renderLoginUI() {
    this.innerHTML = `
      <div class="cart-login-reward">
        <span class="cart-reward-text">Login to Redeem Points</span>
        <a href="/account/login" class="cart-login-btn">Login In</a>
      </div>`;
  }

  renderPointsUI(points) {
    this.innerHTML = `
      <div class="cart-login-reward" style="justify-content:flex-start; gap:5px;">
        ${points > 0 ? `<input type="checkbox" id="ecoline-discount-checkbox">` : ""}
        <label ${points > 0 ? `for="ecoline-discount-checkbox"` : ""} class="cart-reward-text">
          ${points > 0 ? " Redeem now." : ""} You have <strong>${points}${points > 0 ? `(Rs. ${points})` : ""}</strong> redeem points.
        </label>
      </div>`;

    this.discountCheckbox = this.querySelector("#ecoline-discount-checkbox");
    if (this.discountCheckbox) {
      this.discountCheckbox.addEventListener("change", () => this.onCheckboxChange());
    }
  }

  async fetchCustomerInfo(customerId) {
    try {
      const response = await fetch("https://prod-srp.ultiwebtechnologies.com/api/view-customer-points", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shopify_user_id: customerId })
      });

      if (response.ok) {
        const result = await response.json();
        const points = result?.data?.total_points || 0;
        this.discountAmount = points;
        this.renderPointsUI(points);
      } else {
        this.renderPointsUI(0);
        console.error("Failed to fetch tier info");
      }
    } catch (err) {
      console.error("Error fetching tier info:", err);
    }
  }

  async fetchCart() {
    const res = await fetch(window.Shopify.routes.root + "cart.js");
    return await res.json();
  }

  async handleStoredDiscount(cart) {
    const storedCode = localStorage.getItem(this.discountKey);

    if (!storedCode) return;

    const appliedDiscounts = cart?.discount_codes || [];

    // Check if stored code exists in cart discounts
    const match = appliedDiscounts.find(d => d.code === storedCode && d.applicable);
    if (match) {
      this.discountCode = storedCode;
      if (this.discountCheckbox) this.discountCheckbox.checked = true;
    } else {
      localStorage.removeItem(this.discountKey);
    }
  }

  async onCheckboxChange() {
    if (!this.discountCheckbox) return;

    if (this.discountCheckbox.checked) {
      // Generate new discount code
      if (!this.discountCode) {
        await this.generateDiscountCode();
      }
      if (this.discountCode) {
        localStorage.setItem(this.discountKey, this.discountCode);
        this.applyDiscount(this.discountCode);
      }
    } else {
      // Remove discount
      localStorage.removeItem(this.discountKey);
      this.discountCode = null;
      this.applyDiscount(""); // clear
    }
  }

  async generateDiscountCode() {
    try {
      const response = await fetch("https://prod-srp.ultiwebtechnologies.com/api/generate-discount-code", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discountAmount: this.discountAmount })
      });

      if (response.ok) {
        const data = await response.json();
        this.discountCode = data.code;
      } else {
        console.error("Failed to generate discount code");
      }
    } catch (err) {
      console.error("Error generating discount code:", err);
    }
  }

  applyDiscount(code) {
    const formData = new FormData();
    formData.append("discount", code || "");

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData
    })
      .then(res => res.json())
      .then(cart => {
        const cartDrawer = this.closest('m-cart-drawer');
        cartDrawer.onCartDrawerUpdate();
      })
      .catch(err => console.error("Error applying discount:", err));
  }
}

customElements.define("reward-points-box", RewardPointsBox);

class CartComplementaryProducts extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.complementary-products-slider');
    this.cart = document.querySelector("m-cart-drawer");
    this.swiperSlider = null;
  }

  connectedCallback() {
    this.loadCartDrawerRecommendation();
  }

  refreshSlider() {
    if (this.swiperSlider) {
      this.swiperSlider.update();
    }
  }

  async loadCartDrawerRecommendation() {
    try {
      // Fetch current cart
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      if (!cart.items.length) return; // no items in cart

      const cartProductIds = cart.items.map(item => item.product_id);
      let recommendationsHTML = '';

      // Loop through cart items until we find valid related products
      for (const item of cart.items) {
        const sectionUrl = `/recommendations/products?product_id=${item.product_id}&section_id=cart-recommendations`;
        const res = await fetch(sectionUrl);
        const htmlText = await res.text();

        // ✅ Parse HTML response with DOMParser
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');

        // Select product cards (adjust selector for Minimog)
        const productsWrapper = doc.querySelector('.complementary-products-section');

        // Filter out products already in cart
        

        if (productsWrapper) {
          recommendationsHTML = productsWrapper.innerHTML;
          break; // stop after finding first valid set
        }
      }

      if (recommendationsHTML) {
        this.innerHTML = recommendationsHTML;
        this.slider = this.querySelector('.complementary-products-slider');
        this.atcBtns = this.querySelectorAll('[data-atc-btn]');
        this.initEvents();
      }
    } catch (e) {
      console.error('Recommendation error:', e);
    }
  }

  initEvents() {
    if (!this.slider) return;

    // Init Swiper
    this.swiperSlider = new MinimogLibs.Swiper(this.slider, {
      slidesPerView: 4,
        spaceBetween: 16,
      navigation: {
        nextEl: this.querySelector('.swiper-next-button'),
        prevEl: this.querySelector('.swiper-prev-button'),
      },
    });

    // Bind Add to Cart
    this.atcBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', btn.dataset.pid); // Variant ID from data-pid

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        const { MinimogSettings, MinimogStrings } = window;

        fetch(`${MinimogSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (this.cart) {
              this.cart.renderContents(response);
              MinimogTheme.Notification.show({
                target: this.cart.querySelector('m-cart-drawer-items'),
                method: 'prepend',
                type: 'success',
                message: MinimogStrings.itemAdded,
                delay: 400,
              });
              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      });
    });
  }
}

customElements.define('cart-complementary-products', CartComplementaryProducts);